import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading3 = makeDefaultTypographyStyled(
  'Heading3',
  'h3',
  1.72,
  1.2,
);
